import { render } from "./transfer-acquiring-to-card.vue?vue&type=template&id=a7548d62&scoped=true&ts=true"
import script from "./transfer-acquiring-to-card.vue?vue&type=script&lang=ts"
export * from "./transfer-acquiring-to-card.vue?vue&type=script&lang=ts"

import "./transfer-acquiring-to-card.vue?vue&type=style&index=0&id=a7548d62&lang=less&scoped=true"
import "./transfer-acquiring-to-card.vue?vue&type=style&index=1&id=a7548d62&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7548d62"]])

export default __exports__